import React from "react";
import { FaBriefcase, FaClock, FaMapMarkerAlt, FaCalendarAlt, FaFileAlt } from "react-icons/fa";


const Jobsection = () => {
  return (
    <div className="job-details">
      <div className="job-container">
        <div className="job-item">
          <FaBriefcase className="job-icon" />
          <span className="label">Job Category:</span>
          <span className="value">Nursing</span>
        </div>
        <div className="job-item">
          <FaClock className="job-icon" />
          <span className="label">Job Type :</span>
          <span className="value">Full Time</span>
        </div>
        <div className="job-item">
          <FaMapMarkerAlt className="job-icon" />
          <span className="label">Job Location:</span>
          <span className="value">Indore</span>
        </div>
        <div className="job-item">
          <FaCalendarAlt className="job-icon" />
          <span className="label">Job Experience:</span>
          <span className="value">5–9 years</span>
        </div>
        <div className="job-item">
          <FaFileAlt className="job-icon" />
          <span className="label">Job Qualification:</span>
          <span className="value">GNM / B. Sc (Nursing)</span>
        </div>
      </div>
    </div>
  );
};

export default Jobsection;
